<template>
  <div>
    <VueSlickCarousel
      v-bind="settings"
      class="
        slider-digital-agency slider-activation
        rn-slick-dot
        dot-light
        mb--0
        color-white
      "
    >
      <div
        class="slide slide-style-2 fullscreen d-flex align-center bg_image"
        data-black-overlay="5"
        v-for="(slider, i) in sliderContent"
        :key="i"
        :style="{ backgroundImage: 'url(' + slider.src + ')' }"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="text-center inner">
                <h1 class="heading-title">{{ slider.title }}</h1>
                <p class="description">
                  {{ slider.desc }}
                </p>
                <div class="slide-btn">
                  <router-link class="btn-default" to="/contact-us"
                    >Contact Us</router-link
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- End Single Slide  -->
    </VueSlickCarousel>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      sliderContent: [
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_001.jpg"),
          title: "Quality & Affordable",
          desc: `We provide high quality affordable accommodation`,
        },
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_102.jpg"),
          title: "We cover",
          desc: `Birmingham and the West Midlands`,
        },        
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_012.jpg"),
          title: "Landlords & Estate Agents",
          desc: `We work with Landlords, developers and estate agents to provide solutions to their requirements`,         
        },        
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_room_003.jpg"),
          title: "Room Let Housing",
          desc: `Are you looking for room let accommodation with all inclusive bills?`,    
        },
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_006.jpg"),
          title: "Call us now on :",
          desc: `079 8460 6492 or 075 348 94711`,
        },
      ],
      settings: {
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        margin: 20,
        adaptiveHeight: true,
      },
    };
  },
};
</script>

<style lang="scss">
.slick-slide {
  img {
    display: block;
    width: 100%;
  }
}
</style>
